import request from './request';

// 获取所有AI调用流程
export function getCallSchemes() {
  return request({
    url: '/call-schemes',
    method: 'get'
  });
}

// 获取默认AI调用流程
export function getDefaultScheme() {
  return request({
    url: '/call-schemes/default',
    method: 'get'
  });
}

// 获取AI调用流程详情
export function getCallSchemeById(id) {
  return request({
    url: `/call-schemes/${id}`,
    method: 'get'
  });
}

// 获取AI调用流程的步骤列表
export function getSchemeSteps(id) {
  return request({
    url: `/call-schemes/${id}/steps`,
    method: 'get'
  });
}

// 创建AI调用流程
export function createCallScheme(data) {
  return request({
    url: '/call-schemes',
    method: 'post',
    data
  });
}

// 更新AI调用流程
export function updateCallScheme(id, data) {
  return request({
    url: `/call-schemes/${id}`,
    method: 'put',
    data
  });
}

// 设置默认AI调用流程
export function setDefaultScheme(id) {
  return request({
    url: `/call-schemes/${id}/set-default`,
    method: 'put'
  });
}

// 删除AI调用流程
export function deleteCallScheme(id) {
  return request({
    url: `/call-schemes/${id}`,
    method: 'delete'
  });
}

// 为AI调用流程添加步骤
export function addSchemeStep(schemeId, data) {
  return request({
    url: `/call-schemes/${schemeId}/steps`,
    method: 'post',
    data
  });
}

// 批量更新步骤顺序
export function reorderSchemeSteps(schemeId, steps) {
  return request({
    url: `/call-schemes/${schemeId}/steps/reorder`,
    method: 'put',
    data: { steps }
  });
}

// 更新AI调用流程的步骤
export function updateSchemeStep(stepId, data) {
  return request({
    url: `/call-schemes/steps/${stepId}`,
    method: 'put',
    data
  });
}

// 从AI调用流程中移除步骤
export function removeSchemeStep(stepId) {
  return request({
    url: `/call-schemes/steps/${stepId}`,
    method: 'delete'
  });
}

// 设置默认步骤
export function setDefaultStep(stepId) {
  return request({
    url: `/call-schemes/steps/${stepId}/set-default`,
    method: 'put'
  });
}

